import apiClient from './apiClient'
import { Order } from '../entities/queries'
import { getIdOrNull } from '..'

export const API_ERRORS_PREFIX = 'section_groups.errors.'
export const ApiErrors = Object.freeze({
  MISSING_PARAM_NAME: 'missing_param_name',
  MISSING_PARAM_SECTIONS: 'missing_param_sections',
  SECTIONS_CANNOT_BE_EMPTY: 'sections_cannot_be_empty',
  MUST_CONTAIN_AT_LEAST_ONE_OF_SECTORS_OR_INSTITUTION: 'must_contain_at_least_one_of_sectors_or_institution',
  MUST_CONTAIN_ONLY_ONE_OF_SECTORS_OR_INSTITUTION: 'must_contain_only_one_of_sectors_or_institution',
  ALL_SECTORS_MUST_BE_IN_SAME_INSTITUTION: 'all_sectors_must_be_in_same_institution',
  SECTORS_COMBINATION_EXISTS: 'sectors_combination_exists',
  INSTITUTION_COMBINATION_EXISTS: 'institution_combination_exists',
  NAME_ALREADY_EXISTS: 'name_already_exists'
})

export const getErrorTranslation = key => API_ERRORS_PREFIX + ApiErrors[key]

export const createSectionGroup = (user, sectionGroup) => apiClient.post(user, 'api/section-groups', sectionGroup)

const GET_ALL_QUERY_PARAMS = {
  page: 1,
  pageSize: 1,
  order: new Order(),
  search: '',
  filters: {
    name: '',
    institution: '',
    sections: [],
    sectors: [],
    institutional: false
  }
}
export const getAllSectionGroups = (user, queryParams = GET_ALL_QUERY_PARAMS) => apiClient.get(user, 'api/section-groups', queryParams)

export const getBySector = (user, sector) => apiClient.get(user, `api/section-groups/sector/${getIdOrNull(sector)}`)

const GET_BY_SECTORS_PARAMS = { sectors: [], contexts: [] }
export const getBySectors = (user, queryParams = GET_BY_SECTORS_PARAMS) => apiClient.get(user, 'api/section-groups/sectors', queryParams)

export const updateSectionGroup = (user, sectionGroup) => apiClient.patch(user, `api/section-groups/${getIdOrNull(sectionGroup)}`, sectionGroup)

export const deleteSectionGroup = (user, sectionGroup) => apiClient.delete(user, `api/section-groups/${getIdOrNull(sectionGroup)}`)

export const restoreSectionGroup = (user, sectionGroup) => apiClient.patch(user, `api/section-groups/${getIdOrNull(sectionGroup)}/restore`, { sections: sectionGroup.sections.map(getIdOrNull) })

export const deleteSectionGroupSections = (user, sectionGroup, sections) => apiClient.delete(user, `api/section-groups/${getIdOrNull(sectionGroup)}/sections`, { sections })
